:host {
  display: inline-block;
  font-family: var(--cwc-font-sans-serif-bold, 'Eina01-Bold') !important;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1 !important;
  cursor: pointer;
  transition: all 150ms;
  text-transform: uppercase;
  position: relative;
  clip-path: var(--cwc-button-clip-path, unset);
  border-radius: var(--cwc-button-radius, 0);
}

:host::before {
  content: "";
  width: 20px;
  bottom: -1px;
  display: block;
  position: absolute;
  top: 0;
  left: -2px;
  -webkit-clip-path: var(--cwc-button-clip-path, unset);
  clip-path: var(--cwc-button-clip-path, unset);
}

:host a {
  display: block;
  padding: 1em 1.5em;
  color: inherit !important;
  text-decoration: none;
  font-size: inherit !important;
}
